import { useEffect } from "react";
import { useSelector } from "react-redux";
import usePermission from "hooks/permission";
import { isBrand } from "hooks/useBrandType";
import { useHistory } from "react-router-dom";
import * as all from 'constants/permissions';
import usePermissionPlan from "hooks/permissionPlan";
import { isPosProviderConnected } from "utils/checkAccessDenied";
import { isPermissionWithCompanyType } from "hooks/useCompanyType";

const usePosSettings = () => {
  const history = useHistory();
  
  const { isTypeBrand } = isBrand();
  const checkPermission = usePermission();
  const checkPermissionPlan = usePermissionPlan();
  const { isTypeSingle } = isPermissionWithCompanyType();

  const providers = useSelector(({ providers }) => providers);
  const { currentBusiness } = useSelector(({ business }) => business);

  useEffect(() => {
    if (currentBusiness) {
      if (providers?.items?.length > 0 && isTypeSingle) {
        if (!isPosProviderConnected(providers?.items)) {
          const targetRoute = checkPermission(all['HOME_REPORT_FILTER'])
            ? '/home'
            : '/orders';
          history.push(targetRoute);
        }
      } else if (providers?.items?.length === 0 && !isTypeSingle) {
        if (isTypeBrand) {
          history.push('/menu');
        } else {
          const targetRoute =
            checkPermission(all['HOME_REPORT_FILTER']) && isTypeSingle
              ? '/home'
              : '/orders';
          history.push(targetRoute);
        }
      } else if (
        (isTypeSingle &&
          providers?.items?.length === 0 &&
          !checkPermissionPlan(all['APP_BUNDLE'])) ||
        !checkPermission(all['PROVIDERS_VIEW'])
      ) {
        if (!isPosProviderConnected(providers?.items)) {
          history.push('/home');
        }
      }
    }
  }, [
    providers?.items,
    isTypeSingle,
    currentBusiness,
    isTypeBrand,
    checkPermissionPlan,
    checkPermission,
    history,
  ]);

};

export default usePosSettings;